import React from 'react';
import PropTypes from 'prop-types';
// Models
import mRollout from 'models/rollout';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import { listFeatureSearchFieldShape, listFilterShape } from 'constants/PropTypesShapes';
import { dateGenerator } from 'utils/DateUtils';
// Components
import FiltersTemplate from 'components/templates/FiltersTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import DateFilter from 'components/filters/DateFilter';
import ItemsSelectFieldFilter from 'components/filters/ItemsSelectFieldFilter';
import DistributionAutoCompleteFilter from 'distributions/assets/main/DistributionAutoCompleteFilter';
import DeviceAutoCompleteFilter from 'devices/assets/main/DeviceAutoCompleteFilter';

const RolloutFilters = ({
  disabled, advanced, nbFiltersApplied, searchFields, field, filters,
  isFieldDisplayable, onFieldChange, onFilterFieldChange, onReinit, onSwitch,
}) => {
  const {
    begin, end, status, distribution, device,
  } = filters;
  // Dates
  const beginDate = dateGenerator.date(begin.value);
  const endDate = dateGenerator.date(end.value);

  return (
    <FiltersTemplate
      disabled={disabled}
      advanced={advanced}
      nbFiltersApplied={nbFiltersApplied}
      onReinit={onReinit}
      onSwitch={onSwitch}
    >
      <div className="row m-0 pb-3">
        {!advanced && (
          <div className="col-12 col-md-4 col-xl-3">
            <BaseListFilter
              field={field}
              searchFields={searchFields}
              onChange={onFieldChange}
            />
          </div>
        )}
        {isFieldDisplayable('status') && (
          <div className="col-12 col-md-4 col-xl-3">
            <ItemsSelectFieldFilter
              labelId="field.status"
              value={status.value}
              items={mRollout.statusesList}
              onChange={(value) => onFilterFieldChange('status', value)}
            />
          </div>
        )}
        {isFieldDisplayable('begin') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DateFilter
              labelId="field.afterDate"
              type="begin"
              value={beginDate}
              onChange={(value) => onFilterFieldChange('begin', value)}
            />
          </div>
        )}
        {isFieldDisplayable('end') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DateFilter
              labelId="field.beforeDate"
              type="end"
              value={endDate}
              onChange={(value) => onFilterFieldChange('end', value)}
            />
          </div>
        )}
        {isFieldDisplayable('distribution') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DistributionAutoCompleteFilter
              distribution={distribution.value}
              onSelect={(value) => onFilterFieldChange('distribution', value)}
            />
          </div>
        )}
        {isFieldDisplayable('device') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DeviceAutoCompleteFilter
              device={device.value}
              onSelect={(value) => onFilterFieldChange('device', value)}
            />
          </div>
        )}
      </div>
    </FiltersTemplate>
  );
};

RolloutFilters.propTypes = {
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    begin: listFilterShape,
    end: listFilterShape,
    status: listFilterShape,
    distribution: listFilterShape,
    device: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = wrapListFilters(mRollout.listFeatures.searchFields)(RolloutFilters);



// WEBPACK FOOTER //
// ./routes/app/routes/rollouts/assets/main/RolloutFilters.js